import Const from 'constants';

const ShowPlayersExposureWhileOptimized = {
    setShowPlayersExposureWhileOptimizedFromStorage(value) {
        return (dispatch) => {
            dispatch(this.setShowPlayersExposureWhileOptimized(value, {saveToStorage: false}));
        };
    },

    setShowPlayersExposureWhileOptimized(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_SHOW_PLAYERS_EXPOSURE_WHILE_OPTIMIZED,
                    value,
                });

            saveToStorage && dispatch(
                this.saveDataToStorage('showPlayersExposureWhileOptimized', function (state) {
                    const {lineupGenerator} = state;

                    return lineupGenerator.settings.isShowPlayersExposureWhileOptimizedUsed();
                }),
            );
        };
    },
};

export default ShowPlayersExposureWhileOptimized;
